export default {
    maxDate: `Vous devez avoir au moins 13 ans`,
    minDate: `+100 ans, vous ne les faites pas !`,
    invalidDate: `Date invalide`,
};
